var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2502_150844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4793 9.63335C22.4793 8.2933 21.6369 7.0979 20.3749 6.64719L1.97813 0.0769167C1.15215 -0.218084 0.283203 0.394276 0.283203 1.27138V11.2613C0.283203 11.7973 0.620171 12.2755 1.12497 12.4558L9.36922 15.4002C10.1952 15.6952 11.0641 15.0828 11.0641 14.2057V8.46957C11.0641 8.02647 11.507 7.71994 11.9217 7.87601L14.0835 8.6896C15.3193 9.15467 16.1375 10.3369 16.1375 11.6573V14.1552L6.82381 17.5583C6.32354 17.7411 5.99076 18.217 5.99076 18.7497V28.7325C5.99076 29.6135 6.8669 30.2262 7.6944 29.9238L20.3966 25.2825C21.6473 24.8255 22.4793 23.6358 22.4793 22.3042L22.4793 9.63335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2502_150844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.283203 -0.529297L22.4793 7.39788V18.2819C22.4793 19.1589 21.6105 19.7713 20.7845 19.4764L16.1375 17.8173V11.6546C16.1375 10.3336 15.3185 9.1509 14.0819 8.68627L11.9214 7.87449C11.5067 7.71871 11.0641 8.02521 11.0641 8.46815V16.0046L0.283203 12.1543V-0.529297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2502_150844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4792 9.74414C22.4792 11.0757 21.6473 12.2678 20.3966 12.7248L5.99072 17.9885V30.6721L22.4792 24.6473V9.74414Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2502_150844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4792 10.252C22.4792 11.5835 21.6473 12.7756 20.3966 13.2326L5.99072 18.4963V31.1799L22.4792 25.1552V10.252Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.4792 9.61719C22.4792 10.9488 21.6473 12.1408 20.3966 12.5978L5.99072 17.8615V30.5451L22.4792 24.5204V9.61719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.4792 9.61719C22.4792 10.9488 21.6473 12.1408 20.3966 12.5978L5.99072 17.8615V30.5451L22.4792 24.5204V9.61719Z",
    fill: "url(#paint0_linear_2502_150844)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.1378 14.1582L11.0615 16.0153L11.0616 23.4536C11.0616 23.8967 11.5044 24.2032 11.9191 24.0471L14.084 23.2322C15.3196 22.7671 16.1378 21.5849 16.1378 20.2646V14.1582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2502_150844",
    x: 5.73705,
    y: 9.49047,
    width: 16.9956,
    height: 21.4351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.126835,
    result: "effect1_foregroundBlur_2502_150844"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2502_150844",
    x: 3.45402,
    y: 7.71525,
    width: 21.5617,
    height: 26.0011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26835,
    result: "effect1_foregroundBlur_2502_150844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2502_150844",
    x1: 22.4792,
    y1: 17.7937,
    x2: 16.1617,
    y2: 17.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287843,
    stopColor: "#94B9FF",
    stopOpacity: 0.523646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538FFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.7597e9b1f48de4b08f3b332a284eebd0.svg";
export { ForwardRef as ReactComponent };